/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import React, { useState } from 'react'

import { View } from '@components/atoms'
import { SeasonListItem } from '@components/molecules'
import { SeasonType } from '@schemas'
import { SeasonDeleteConfirmationModal } from '@components/molecules'
import { useAppDispatch } from '@redux/index'
import { seasonActions } from '@redux/store/index'
import { useNavigate } from 'react-router-dom'

interface SeasonListProps {
	seasons: SeasonType[]
	selectedSeasonId: string
	onSeasonClick: (season: SeasonType) => void
	/** 대기열에 넣기. 날짜 역전 검사는 호출부(Season.page)가 한다. */
	onAddToQueue: (season: SeasonType) => void
}

export const SeasonList = (props: SeasonListProps) => {
	const { seasons, selectedSeasonId, onSeasonClick, onAddToQueue } = props

	const dispatch = useAppDispatch()
	const navigate = useNavigate()
	const [deleteModalOpen, setDeleteModalOpen] = useState(false)
	const [selectedSeason, setSelectedSeason] = useState<SeasonType | null>(null)

	const handleDeleteClick = (season: SeasonType) => {
		setSelectedSeason(season)
		setDeleteModalOpen(true)
	}

	// 수정은 전체 화면(FullModalLayout)이라 라우트로 이동한다
	const handleModifyClick = (season: SeasonType) => {
		navigate(`/main/season/${season.id}/edit`)
	}

	const handleDelete = () => {
		if (selectedSeason) {
			dispatch(seasonActions.DELETE_SEASON(selectedSeason.id))
			setDeleteModalOpen(false)
			setSelectedSeason(null)
		}
	}

	return (
		<View css={style}>
			<View className="seasonListView">
				{seasons && seasons.length > 0 ? (
					seasons.map(season => {
						const isSelected = season.id === selectedSeasonId
						return (
							<SeasonListItem
								key={season.id}
								{...season}
								isSelected={isSelected}
								onClick={() => onSeasonClick(season)}
								onDelete={() => handleDeleteClick(season)}
								onEdit={() => handleModifyClick(season)}
								onAddToQueue={() => onAddToQueue(season)}
							/>
						)
					})
				) : (
					<p>No seasons available.</p>
				)}
			</View>

			<SeasonDeleteConfirmationModal
				open={deleteModalOpen}
				onClose={() => setDeleteModalOpen(false)}
				onDelete={handleDelete}
				seasonTitle={selectedSeason ? selectedSeason.title : ''}
			/>
		</View>
	)
}

const style = css({
	overflow: 'auto',
	height: '100%',
	width: '100%',
	padding: '0.5rem 1rem',

	seasonListView: {},
})
